import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-initiatives',
  templateUrl: './initiatives.component.html',
  styleUrls: ['./initiatives.component.scss']
})
export class InitiativesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
